class FiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debounceTimeout = null;
  }

  connectedCallback() {
    this.initialize();
    this.setupDrawerHandlers();
    this.updateItemCount();
  }

  initialize() {
    this.filterForm = this.querySelector('#filter-form');
    this.collectionName = this.filterForm?.getAttribute('data-collection-name');
    this.sortBySelect = this.querySelector('#sort-by');
    this.priceRangeSlider = this.querySelector('price-range-slider');
    this.productGridContainer = document.querySelector('#ProductGridContainer');
    this.activeFiltersContainer = document.querySelector('#ActiveFiltersContainer');

    this.dropDownTrigger = this.querySelector('.dropdown-trigger')
    this.dropDownMenu = this.querySelector('.dropdown-menu')
    this.dropDownOptions = this.querySelectorAll('.dropdown-item')
    
    this.applyButton = document.querySelector('.apply-button');
    this.resetButton = document.querySelector('#reset-filters-btn');
    this.itemCountElement = document.querySelector('#items-count');

    this.dropdownMenuSort()
    this.setupPriceRangeHandlers();
    this.setupColorFilterHandlers();
    this.setupFilterButtons();

    this.dropDownTrigger?.addEventListener('click',()=>this.dropDownMenu.classList.toggle("hidden"))

    document.addEventListener('click', (event) => {
      if (this.dropDownMenu && !this.dropDownMenu.contains(event.target) && !this.dropDownTrigger.contains(event.target)) {
        this.dropDownMenu.classList.add("hidden");
      }
    });
      

    if (this.filterForm) {
      this.filterForm.addEventListener('change', (event) => {
        if (['checkbox', 'number'].includes(event.target.type)) {
          this.updateButtonState();
          this.previewItemCount();
        }
      });
    }

    this.sortBySelect?.addEventListener('change', () => this.updateSorting());
    this.priceRangeSlider?.addEventListener('change', () => this.updateFilters());

  }

  updateItemCount() {
    const productGrid = document.querySelector('#ProductGridContainer');
    if (productGrid) {
      this.currentItemCount = this.getProductsCount(productGrid);
      this.updateItemCountDisplay(this.currentItemCount);
    }
  }

  // The grid only holds the first page, so the total comes from collection.products_count
  getProductsCount(container) {
    const productGrid = container.querySelector('#product-grid');
    return Number(productGrid?.dataset.productsCount ?? container.querySelectorAll('.product-card').length);
  }

  updateItemCountDisplay(count) {
    if (this.itemCountElement) {
      this.itemCountElement.textContent = `Show ${count} Items`;
    }
  }


  previewItemCount() {
    const formData = new FormData(this.filterForm);
    const queryParams = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (!key.includes('filter.v.price')) {
        queryParams.append(key, value);
      }
    }


    const minPriceInput = this.filterForm.querySelector('input[name="filter.v.price.gte"]:checked');
    const maxPriceInput = minPriceInput ? minPriceInput.closest('.filter-group-display__list-item').querySelector('input[name="filter.v.price.lte"]') : null;
    if (minPriceInput && minPriceInput.checked && maxPriceInput) {
      queryParams.set('filter.v.price.gte', minPriceInput.value);
      queryParams.set('filter.v.price.lte', maxPriceInput.value);
    }

    // Preview request
    fetch(`/collections/${this.collectionName}?${queryParams.toString()}`)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        const productGrid = doc.querySelector('#ProductGridContainer');
        if (productGrid) {
          this.updateItemCountDisplay(this.getProductsCount(productGrid));
        }
      })
      .catch((error) => console.error('Error fetching preview count:', error));
  }

  setupFilterButtons() {
    // Remove existing listeners to prevent duplicates
    if (this.applyButton) {
      this.applyButton.removeEventListener('click', this.applyClickHandler);
      this.applyClickHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.applyButton.disabled) return;
        this.updateFilters();
      };
      this.applyButton.addEventListener('click', this.applyClickHandler);
    }

    if (this.resetButton) {
      this.resetButton.removeEventListener('click', this.resetClickHandler);
      this.resetClickHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.resetButton.disabled) return;
        this.resetFilters();
      };
      this.resetButton.addEventListener('click', this.resetClickHandler);
    }
  }

  updateButtonState() {
    // Enable apply button when filters are changed
    if (this.applyButton) {
      this.applyButton.disabled = false;
      this.applyButton.classList.remove('opacity-50');
    }
  }

  resetFilters() {
    const checkboxes = this.filterForm.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });


    if (this.priceRangeSlider) {
      this.priceRangeSlider.resetToDefault();
    }


    const queryParams = new URLSearchParams();
    const currentUrl = new URLSearchParams(window.location.search);

    const sortValue = currentUrl.get('sort_by') || this.sortBySelect?.value;
    if (sortValue) {
      queryParams.set('sort_by', sortValue);
    }
    this.fetchAndUpdate(queryParams);
    
    // Disable apply button
    if (this.applyButton) {
      this.applyButton.disabled = true;
      this.applyButton.classList.add('opacity-50');
    }

    this.updateItemCount();
  }


  setupPriceRangeHandlers() {
    const priceCheckboxes = this.querySelectorAll('.price-range-checkbox');
    
    priceCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (event) => {
        priceCheckboxes.forEach(cb => {
          if (cb !== event.target) {
            cb.checked = false;
          }
        });
        
        // this.updateFilters();
      });
    });
  }

  setupColorFilterHandlers() {
    // Handle all color filter checkboxes (including fallback text ones)
    const colorCheckboxes = this.querySelectorAll('input[type="checkbox"][id*="color-"]');
    
    colorCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (event) => {
        // Force update of visual state
        const label = event.target.closest('label');
        if (label) {
          // Trigger a reflow to ensure visual updates
          label.offsetHeight;
        }
        
        // Update button state and preview
        this.updateButtonState();
        this.previewItemCount();
      });
    });
  }

  dropdownMenuSort(){
    this.dropDownOptions?.forEach(option => {
      if(option.hasAttribute('selected')){
        this.dropDownTrigger.textContent = option.textContent; 
      }
      option.addEventListener('click', () => {
        const value = option.getAttribute('data-value');
        this.dropDownTrigger.textContent = option.textContent; 
        console.log('Selected value:', value);
        
        const queryParams = new URLSearchParams(window.location.search);
        if (value) {
          queryParams.set('sort_by', value); 
        }
        this.fetchAndUpdate(queryParams);
        this.dropDownMenu.classList.add("hidden");
      });
    });
  }

  setupDrawerHandlers() {
    const triggerOpen = document.getElementById('filter-drawer-open');
    const triggerClose = document.getElementById('filter-drawer-close');
    const drawer = document.getElementById('filter-drawer');
    const drawerOverlay = document.getElementById('filter-drawer-overlay');

    if (triggerOpen && triggerClose && drawer) {
      const toggleDrawer = (isOpen) => {
        drawer.classList.toggle('filter-open', isOpen);
        document.body.classList.toggle('!overflow-hidden', isOpen);
        drawerOverlay.classList.toggle('hidden', !isOpen);
      };

      triggerOpen.addEventListener('click', () => toggleDrawer(true));
      triggerClose.addEventListener('click', () => toggleDrawer(false));
      drawerOverlay?.addEventListener('click', () => toggleDrawer(false));
    }
  }

  setLoadingState(isLoading) {
    this.filterForm?.classList.toggle('loading', isLoading);
    
    // Disable buttons during loading to prevent double-clicks
    if (this.applyButton) {
      this.applyButton.disabled = isLoading;
      this.applyButton.classList.toggle('opacity-50', isLoading);
    }
    if (this.resetButton) {
      this.resetButton.disabled = isLoading;
      this.resetButton.classList.toggle('opacity-50', isLoading);
    }
  }

  fetchAndUpdate(queryParams) {
    const queryString = queryParams.toString();

    this.setLoadingState(true);
    fetch(`/collections/${this.collectionName}?${queryString}`)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');

        const newProductGrid = doc.querySelector('#ProductGridContainer');
        const newActiveFilters = doc.querySelector('#ActiveFiltersContainer');
        const newFiltersForm = doc.querySelector('#filters-form');
        const loadForm = this.querySelector(`[data-load-form]`);
        
        if (newProductGrid) {
          this.productGridContainer.innerHTML = newProductGrid.innerHTML;
          this.currentItemCount = this.getProductsCount(newProductGrid);
          this.updateItemCountDisplay(this.currentItemCount);
        }

        if (newActiveFilters) {
          this.activeFiltersContainer.innerHTML = newActiveFilters.innerHTML;
        }
        

        if (newFiltersForm && !loadForm) {
          this.innerHTML = newFiltersForm.innerHTML;
          this.initialize();
          this.setupDrawerHandlers();
        }

        history.replaceState(null, null, `?${queryString}`);
        document.dispatchEvent(new Event('filter-applied'));
      })
      .catch((error) => console.error('Error fetching data:', error))
      .finally(() => this.setLoadingState(false));
  }


  updateFilters() {
    const formData = new FormData(this.filterForm);
    const queryParams = new URLSearchParams();
    const currentUrl = new URLSearchParams(window.location.search);
    const sortValue = currentUrl.get('sort_by') || this.sortBySelect?.value;

    // to remove the prices if checkbox is unchecked
    for (const [key, value] of formData.entries()) {
      if (!key.includes('filter.v.price')) {
        queryParams.append(key, value);
      }
    }
  
    // add price queryParams if the price checkbox is checked
    const minPriceInput = this.filterForm.querySelector('input[name="filter.v.price.gte"]:checked');
    const maxPriceInput = minPriceInput ? minPriceInput.closest('.filter-group-display__list-item').querySelector('input[name="filter.v.price.lte"]') : null;
    if (minPriceInput && minPriceInput.checked && maxPriceInput) {
      queryParams.set('filter.v.price.gte', minPriceInput.value);
      queryParams.set('filter.v.price.lte', maxPriceInput.value);
    }
  
    if (sortValue) {
      queryParams.set('sort_by', sortValue);
    }
  
    this.fetchAndUpdate(queryParams);
  }
  updateSorting() {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('sort_by', this.sortBySelect.value);
    this.fetchAndUpdate(queryParams);
  }

  debounce(callback, delay) {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(callback, delay);
  }
}

customElements.define('filters-form', FiltersForm);


// Infinite scroll for the collection grid: when the loader nears the viewport, it fetches the next page of the
// section (Section Rendering API) and appends its cards. Filtering swaps #ProductGridContainer, which brings a new loader.
class CollectionLoadMore extends HTMLElement {
  connectedCallback() {
    this.grid = document.querySelector('#product-grid');
    this.failures = 0;

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadNext();
      },
      // Above the viewport too, for a loader the visitor scrolled past while the previous page was loading
      { rootMargin: '800px 0px 800px 0px' }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async loadNext() {
    const nextUrl = this.dataset.nextUrl;
    if (this.loading || !nextUrl || !this.grid) return;

    this.loading = true;

    try {
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      // A filter or sort change replaced the grid while this page was loading
      if (!this.isConnected) return;

      const items = Array.from(doc.querySelector('#product-grid')?.children ?? []);
      this.grid.append(...items);
      items.forEach((item) => this.runScripts(item));

      const next = doc.querySelector('collection-load-more');
      if (!next) {
        this.remove();
        return;
      }
      this.dataset.nextUrl = next.dataset.nextUrl;
      this.failures = 0;
      this.observeAgain();
    } catch (error) {
      console.error('Error loading more products:', error);
      // Retry a few times while the loader is still in range
      if (++this.failures < 3) setTimeout(() => this.observeAgain(), 2000);
    } finally {
      this.loading = false;
    }
  }

  // Observing again delivers a fresh callback, so a loader that's still in range (tall screens) loads straight away
  observeAgain() {
    if (!this.isConnected) return;
    this.observer.unobserve(this);
    this.observer.observe(this);
  }

  // Scripts in parsed HTML don't run when inserted (e.g. the card's pre-order plan picker), so swap in fresh copies
  runScripts(root) {
    root.querySelectorAll('script:not([type]), script[type="text/javascript"], script[type="module"]').forEach((oldScript) => {
      const script = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attribute) => script.setAttribute(attribute.name, attribute.value));
      script.textContent = oldScript.textContent;
      oldScript.replaceWith(script);
    });
  }
}

customElements.define('collection-load-more', CollectionLoadMore);




class PriceRangeSlider extends HTMLElement {
  constructor() {
    super();
    this.minLimit = 0;
    this.maxLimit = 1000;
    this.isDragging = false;
    this.currentKnob = null;
  }

  connectedCallback() {
    this.initElements();
    this.getValues();
    this.setInitialPositions();
    this.addEventListeners();
  }

  initElements() {
    this.minKnob = this.querySelector('[data-knob-left]');
    this.maxKnob = this.querySelector('[data-knob-right]');
    this.progressBar = this.querySelector('[data-progress-bar]');
    this.activeBar = this.querySelector('[data-active-progress-bar]');
    this.minInput = this.querySelector('input[name$="gte"]');
    this.maxInput = this.querySelector('input[name$="lte"]');
  }

  getValues() {
    this.minLimit = parseInt(this.dataset.minLimit, 10) || 0;
    this.maxLimit = parseInt(this.dataset.maxLimit, 10) || 1000;
  }

  setInitialPositions() {
    this.updateKnobPosition(this.minKnob, this.minInput.value || this.minLimit);
    this.updateKnobPosition(this.maxKnob, this.maxInput.value || this.maxLimit);
    this.updateActiveBar();
  }

  updateKnobPosition(knob, value) {
    const percentage = ((value - this.minLimit) / (this.maxLimit - this.minLimit)) * 100;
    knob.style.left = `${percentage}%`;
    knob.dataset.value = value;
  }

  updateActiveBar() {
    const minLeft = parseFloat(this.minKnob.style.left) || 0;
    const maxLeft = parseFloat(this.maxKnob.style.left) || 100;
    this.activeBar.style.left = `${minLeft}%`;
    this.activeBar.style.width = `${maxLeft - minLeft}%`;
  }

  addEventListeners() {
    this.addKnobListeners(this.minKnob);
    this.addKnobListeners(this.maxKnob);
    this.minInput.addEventListener("change", (e) => this.updateFromInput(e, this.minKnob));
    this.maxInput.addEventListener("change", (e) => this.updateFromInput(e, this.maxKnob));
  }

  addKnobListeners(knob) {
    knob.addEventListener("mousedown", (e) => this.startDrag(e, knob));
    knob.addEventListener("touchstart", (e) => this.startDrag(e, knob));
    document.addEventListener("mousemove", (e) => this.doDrag(e));
    document.addEventListener("touchmove", (e) => this.doDrag(e));
    document.addEventListener("mouseup", () => this.endDrag());
    document.addEventListener("touchend", () => this.endDrag());
  }

  startDrag(e, knob) {
    e.preventDefault();
    this.isDragging = true;
    this.currentKnob = knob;
  }

  doDrag(e) {
    if (!this.isDragging) return;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const rect = this.progressBar.getBoundingClientRect();
    let newLeft = ((clientX - rect.left) / rect.width) * 100;

    if (newLeft < 0) newLeft = 0;
    if (newLeft > 100) newLeft = 100;

    if (this.currentKnob === this.minKnob) {
      const maxLeft = parseFloat(this.maxKnob.style.left);
      if (newLeft > maxLeft) newLeft = maxLeft;
    } else if (this.currentKnob === this.maxKnob) {
      const minLeft = parseFloat(this.minKnob.style.left);
      if (newLeft < minLeft) newLeft = minLeft;
    }

    this.currentKnob.style.left = `${newLeft}%`;
    const value = Math.round(
      this.minLimit + (newLeft / 100) * (this.maxLimit - this.minLimit)
    );
    this.currentKnob.dataset.value = value;

    this.updateActiveBar();
    this.updateInputs();
  }

  endDrag() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.currentKnob = null;
    this.dispatchFilterEvent();
  }

  updateFromInput(e, knob) {
    let value = parseInt(e.target.value);
    const isValid = value >= this.minLimit && value <= this.maxLimit;

    if (value < this.minLimit) {
      this.minInput.value = this.minLimit;
    } else if (value > this.maxLimit){
      this.maxInput.value = this.maxLimit
    }

    if (!isValid) return;
    
    if (knob === this.minKnob && value > parseInt(this.maxInput.value, 10)) {
      this.minInput.value = parseInt(this.maxInput.value, 10);
      value = parseInt(this.maxInput.value, 10);
    } else if (knob === this.maxKnob && value < parseInt(this.minInput.value, 10)) {
      this.maxInput.value = parseInt(this.minInput.value, 10);
      value = parseInt(this.minInput.value, 10);
    }

    this.updateKnobPosition(knob, value);
    this.updateActiveBar();
    this.dispatchFilterEvent();
  }

  updateInputs() {
    this.minInput.value = this.minKnob.dataset.value;
    this.maxInput.value = this.maxKnob.dataset.value;
  }

  dispatchFilterEvent() {
    this.dispatchEvent(new Event("change", { bubbles: true }));
  }
}

customElements.define("price-range-slider", PriceRangeSlider);